import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { Policy } from 'src/domains/players/webview/components/Account/resetPasswordProcedure/resetPasswordForm/Policy';

export const ResetPasswordPrivacy = observer('ResetPasswordPrivacy', () => {
    return <Policy id='privacy-policy' />;
});
